import { render, staticRenderFns } from "./EntityForm.vue?vue&type=template&id=37f51d60&scoped=true"
import script from "./EntityForm.vue?vue&type=script&lang=js"
export * from "./EntityForm.vue?vue&type=script&lang=js"
import style0 from "./EntityForm.vue?vue&type=style&index=0&id=37f51d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f51d60",
  null
  
)

export default component.exports